import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'srp-logging-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'srp-logging-error-dialog' },
    standalone: false,
})

export class ErrorDialogComponent {

    private static _nextId = 0;

    @HostBinding() id = `srp-logging-error-dialog-${ErrorDialogComponent._nextId++}`;

    title: string;
    message: string;
    choices: string[];

    constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>) {
    }

    onClick(choice: string): void {
        this.dialogRef.close(choice);
    }
}
